import * as React from 'react';
import SchemaModels from './SchemaModels';


export type TabsContentModelsBaseProps = {
  schemaId: string,
  schemaName: string
}

type TabsContentModelsProps = TabsContentModelsBaseProps & {
  isVisible: boolean
}

const TabsContentModels = (props: TabsContentModelsProps) => {


  return <div hidden={!props.isVisible}>
    <SchemaModels id={props.schemaId} name={props.schemaName} />
  </div>
}

export default TabsContentModels;
